﻿'use strict';

angular.module('ntmApp').factory('StaffSchedules', ['StaffSchedulesFilter', 'ForecastService', 'FlashService', 'UnAssignedActivities', 'Utils', 'ForecastingFiltersProvider', 'ActivityUtils',
    function (StaffSchedulesFilter, ForecastService, FlashService, UnAssignedActivities, Utils, ForecastingFiltersProvider, ActivityUtils) {

        function StaffSchedules(ForecastContext) {

            var self = this;
            var context = ForecastContext;

            self.UnAssignedActivities = new UnAssignedActivities(context, context.forecastMode);
            self.Filter = new StaffSchedulesFilter();

            self.showFilter = false;

            self.loadForecastStaffHeaders = function (header, selectedWeek) {

                var request = context.prepareDataForRequest();

                request.forecastView = header.forecastOptionsSummary.forecastView;
                request.forecastScope = header.selectedForecastScope.id.trim();
                request.dateFrom = selectedWeek.startDate;
                request.dateTo = selectedWeek.endDate;

                self.forecastView = header.forecastOptionsSummary.forecastView;

                self.dataLoading = true;

                ForecastService.GetForecastStaff(request).then(function (result) {
                    self.staffBlockHeaders = result.data.staffBlockHeaders;
                    self.staffItems = getStaffItems(self.staffBlockHeaders);

                    if (self.staffBlockHeaders) {
                        self.staffBlockHeaders.forEach(function (block) {
                            block.availableHours.forEach(function (dow) {
                                dow.dndTarget = [];
                                dow.blockHeader = {
                                    personId: block.personId,
                                    staffName: block.staffName
                                };
                            });
                            block.availableHours = fillCorrespondingDOW(getDOWContainer(selectedWeek), block.availableHours);
                        });
                    }

                    if (!self.soringAttributes.sortBy.sortKey) {
                        self.sortBy(self.soringAttributes.byStaffName.key);
                    }

                    ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                        if (filters) {
                            self.roles = filters.staffRoleFilters;
                            Utils.AddBlankOption(self.roles);
                        }

                        self.dataLoading = false;
                    });

                });
            };

            function getDOWContainer(selectedWeek) {
                var DOWContainerArray = [];

                var day = selectedWeek.startDate;

                for (var i = 0; i <= selectedWeek.endDate.diff(selectedWeek.startDate, 'days') ; i++) {
                    DOWContainerArray.push(day);

                    day = day.clone().add(1, 'd');
                }

                return DOWContainerArray;
            }

            function fillCorrespondingDOW(dowContainer, dowHours) {

                for (var i = 0; i < dowContainer.length; i++) {
                    for (var j = 0; j < dowHours.length; j++) {
                        if (moment(dowContainer[i]).isSame(dowHours[j].date, 'day')) {
                            dowContainer[i] = dowHours[j];

                            break;
                        }
                    }
                }

                return dowContainer;
            }

            self.getDOWHeaderByStaffName = function (personId) {
                var header = {};
                self.staffBlockHeaders.forEach(function (block) {
                    if (block.personId === personId) {
                        header = block;
                    }
                });

                return header;
            };

            self.reloadStaffBlockHeader = function (header, blockHeader, selectedWeek) {

                var request = context.prepareDataForRequest();

                request.personId = blockHeader.personId;
                request.dateFrom = selectedWeek.startDate;
                request.dateTo = selectedWeek.endDate;
                request.forecastView = header.forecastOptionsSummary.forecastView;
                request.forecastScope = header.selectedForecastScope.id.trim();
                request.isSetupNotIn = blockHeader.isSetupNotIn;

                var activeDOW = blockHeader.availableHours.firstOrDefault(function (dow) {
                    return dow.active;
                });

                if (activeDOW) {
                    request.date = activeDOW.date;
                }

                var loading = FlashService.Loading();
                ForecastService.ReloadStaffBlockHeader(request).then(function (result) {

                    loading.dismiss();

                    if (result.success) {

                        blockHeader.availableHours = result.data.blockHeader.availableHours;
                        blockHeader.averageAvailableHours = result.data.blockHeader.averageAvailableHours;
                        blockHeader.standardDeviation = result.data.blockHeader.standardDeviation;

                        blockHeader.availableHours.forEach(function (dow) {
                            dow.dndTarget = [];
                            dow.blockHeader = {
                                personId: blockHeader.personId,
                                staffName: blockHeader.staffName
                            };

                            if (activeDOW) {

                                var currentDOWDate = moment(dow.date);
                                var activeDOWDate = moment(activeDOW.date);

                                if (currentDOWDate.isSame(activeDOWDate)) {
                                    dow.active = true;
                                    applyActivitiesGrid(blockHeader, currentDOWDate, result.data.dowActivities);
                                }
                            }
                        });
                    }
                });
            };

            self.selectActivitiesOfDay = function (header, dowHours, blockHeader) {

                blockHeader.availableHours.forEach(function (dow) {

                    if (dow !== dowHours) {
                        dow.active = false;
                    }
                });

                dowHours.active = !dowHours.active;

                if (dowHours.active) {
                    var dowDate = moment(dowHours.date);

                    loadDowActivities(header, blockHeader, dowDate);

                } else {
                    blockHeader.currentGrid = null;
                }

            };

            function loadDowActivities(header, blockHeader, dateToSelect) {

                var request = context.prepareDataForRequest();

                request.personId = blockHeader.personId;
                request.date = dateToSelect;
                request.forecastView = header.forecastOptionsSummary.forecastView;
                request.forecastScope = header.selectedForecastScope.id.trim();

                blockHeader.activitiesAreLoading = true;
                
                ForecastService.GetForecastStaffGrid(request).then(function (result) {

                    blockHeader.activitiesAreLoading = false;

                    if (result.success) {

                        applyActivitiesGrid(blockHeader, dateToSelect, result.data.dowActivities);

                        if (result.data.assignedOthers) {
                            blockHeader.assignedOthers = result.data.assignedOthers;
                            blockHeader.assignedOthersHours = result.data.assignedOthers.reduce(function (sum, item) { return sum + item.totalDuration; }, 0);
                        }
                    }
                });
            }

            self.displayDOWHours = function (dowHours) {

                var isHoursDefined = angular.isNumber(dowHours.hours);
                var hours = isHoursDefined ? parseFloat(dowHours.hours).toFixed(2) : dowHours.hours;

                return "{0}: {1}".format(dowHours.dayLabel, hours);
            };

            function applyActivitiesGrid(blockHeader, date, activities) {

                var grouppedActvivities = ActivityUtils.GroupByCategories(activities, function(group) {

                    group.date = date;
                    group.personId = blockHeader.personId;

                    if (group.grouppedByLocate) {

                        group.groupsByLocate.forEach(function (byLocate) {

                            byLocate.date = date;
                            byLocate.personId = blockHeader.personId;
                            byLocate.items.forEach(function (activity) {
                                activity.personId = blockHeader.personId;
                            });
                            byLocate.icons = context.getUniqueIcons(byLocate.items);
                        });
                    } else {

                        group.items.forEach(function (activity) {
                            activity.personId = blockHeader.personId;
                        });
                    }

                    group.icons = context.getUniqueIcons(group.getActivities());

                });

                var dow = blockHeader.availableHours.firstOrDefault(function (item) {
                    return moment(item.date).isSame(date, 'day');
                });

                var grid = {
                    grouppedActvivities: grouppedActvivities,
                    dayOfWeek: date.day(),
                    dowHours: dow,
                    date: date
                };

                if (blockHeader.currentGrid) {
                    grid.grouppedActvivities.syncExpandedState(blockHeader.currentGrid.grouppedActvivities);
                }

                blockHeader.currentGrid = grid;
            }

            self.expandAllActivities = function (grid) {
                grid.grouppedActvivities.setExpandedState(true);
            };

            self.collapseAllActivities = function (grid) {
                grid.grouppedActvivities.setExpandedState(false);
            };

            self.defaultDragAndDropTargetsForBlockHeaders = function () {

                self.staffBlockHeaders.forEach(function (block) {
                    block.availableHours.forEach(function (dow) {
                        dow.dndTarget = [];
                    });
                });
            };

            self.collapseAllBlockHeaders = function () {

                if (self.staffBlockHeaders) {
                    self.staffBlockHeaders.forEach(function (block) {
                        block.availableHours.forEach(function (dow) {
                            dow.active = false;
                        });
                        block.currentGrid = null;
                    });
                }
            };

            self.toggleFilter = function () {
                self.showFilter = !self.showFilter;
            };

            self.togglePinState = function (blockHeader) {
                blockHeader.pinned = !blockHeader.pinned;
            };


            self.SORTING_STATE = {
                NONE: "NONE",
                ASC: "ASC",
                DESC: "DESC"
            };

            self.soringAttributes = {
                byStaffName: {
                    key: 'staffName',
                    value: self.SORTING_STATE.NONE
                },
                byAverageAvailable: {
                    key: 'averageAvailableHours',
                    value: self.SORTING_STATE.NONE
                },
                byStandartDeviation: {
                    key: 'standardDeviation',
                    value: self.SORTING_STATE.NONE
                },

                sortBy: {
                    reverse: false
                },

                apply: function (key) {

                    for (var property in this) {
                        if (this.hasOwnProperty(property) && !angular.isFunction(this[property])) {
                            var attr = this[property];

                            if (attr.key === key) {
                                attr.value = attr.value === self.SORTING_STATE.NONE ?
                                    self.SORTING_STATE.ASC :
                                    attr.value === self.SORTING_STATE.ASC ?
                                                   self.SORTING_STATE.DESC :
                                                   self.SORTING_STATE.ASC;

                                this.sortBy.sortKey = key;
                                this.sortBy.reverse = attr.value === self.SORTING_STATE.DESC;

                            } else {
                                attr.value = self.SORTING_STATE.NONE;
                            }
                        }
                    }
                }
            };

            self.sortBy = function (sortingKey) {
                self.soringAttributes.apply(sortingKey);
            };

            self.clearAllPins = function () {

                if (self.staffBlockHeaders) {
                    self.staffBlockHeaders.forEach(function (block) {
                        block.pinned = false;
                    });
                }

                self.showOnlyPinned = false;
            };

            self.loadUnAssignedActivitiesPane = function (header, selectedWeek, preventTabsRecreating) {
                self.UnAssignedActivities.load(header, selectedWeek, context.scenarioId, preventTabsRecreating);
            };

            self.loadRightPanes = function (header, selectedWeek) {
                self.loadUnAssignedActivitiesPane(header, selectedWeek);
            };

            self.reload = function (header, selectedWeek) {
                self.loadForecastStaffHeaders(header, selectedWeek);
                self.loadRightPanes(header, selectedWeek);
            };

            self.selectStaff = function () {
                self.selectedStaff = self.filterSelectedStaff;
            };

            function getStaffItems(blockHeaders) {

                if (blockHeaders) {
                    return blockHeaders.map(function (block) {
                        return {
                            id: block.personId,
                            value: block.staffName
                        };
                    }).unique(function (staff1, staff2) {
                        return staff1.id === staff2.id;
                    });
                }

                return [];
            }
        }
  
        return (StaffSchedules);
    }]);